import { render, staticRenderFns } from "./editorPopoverNotification.vue?vue&type=template&id=69ef9b46&scoped=true&"
import script from "./editorPopoverNotification.vue?vue&type=script&lang=js&"
export * from "./editorPopoverNotification.vue?vue&type=script&lang=js&"
import style0 from "./editorPopoverNotification.vue?vue&type=style&index=0&id=69ef9b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef9b46",
  null
  
)

export default component.exports